import React, { FC } from "react";
import { Tooltip } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { SymbolLibraryButton } from "./SymbolLibraryButton";

// eslint-disable-next-line max-len
import { TOOLTIP_DELAY_XY } from "../../../Classification/components/InputsAndValues/components/NonEditableField/NonEditableField";

import { SymbolLibraryProps } from "./types";

export const SymbolLibrary: FC<SymbolLibraryProps> = ({ children, mini, ...symbolLibraryProps }) => {
  const { t } = useTranslation("common");

  return mini ? (
    <Tooltip
      flip={false}
      distance={8}
      arrow
      placement={"top"}
      content={t("symbolActions.chooseSymbol")}
      delay={TOOLTIP_DELAY_XY}
    >
      {ref => <SymbolLibraryButton {...symbolLibraryProps} innerRef={ref} />}
    </Tooltip>
  ) : (
    <SymbolLibraryButton {...symbolLibraryProps}>{children}</SymbolLibraryButton>
  );
};
